import ReactDOM from 'react-dom';
import { useModal } from 'src/ModalContext';
import Button from './Button';
import { useTranslation } from 'react-i18next';

export default function Modal(): JSX.Element | null {
  const { t } = useTranslation();
  const { isShow, modal, hideModal } = useModal();
  const hasComponent = modal && !!modal.component;
  const hasFailCallback = modal && typeof modal.fail === 'function';
  const onSuccess = () => {
    hideModal();
    modal && typeof modal.success === 'function' && modal.success();
  };
  const onFail = () => {
    hideModal();
    hasFailCallback && modal.fail();
  };

  if (isShow && modal) {
    return ReactDOM.createPortal(
      <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center" style={{ zIndex: 100 }}>
        <div className="absolute top-0 left-0 w-full h-full bg-black bg-opacity-60" style={{ zIndex: 101 }} tabIndex={-1}></div>
        <div className="bg-white w-78 rounded px-6 pt-7 pb-5" style={{ zIndex: 102 }}>
          {hasComponent ? (
            modal.component
          ) : (
            <div className="text-black text-center flex flex-col justify-center items-center" style={{ minHeight: '6.25rem' }}>
              {modal.title && !!modal.title.length && <p className="N_16_M">{modal.title}</p>}
              <p className="N_16_R whitespace-pre-wrap">{modal.message}</p>
            </div>
          )}

          <div className="mt-7 flex justify-between items-center">
            {hasFailCallback && (
              <div className="w-32">
                <Button theme="sub" title={t('popup/cancel_button_title')} onClick={onFail} />
              </div>
            )}
            <div className={hasFailCallback ? 'w-32' : 'w-full'}>
              <Button title={t(hasFailCallback ? 'popup/ok_button_title' : 'popup/close_button_title')} onClick={onSuccess} />
            </div>
          </div>
        </div>
      </div>,
      document.getElementById('modal-root') as HTMLElement,
    );
  } else {
    return null;
  }
}
